import { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import DeliveryDateArea from '@ui-parts/DeliveryDateArea';
import UserInfoArea from '@ui-parts/UserInfoArea';

import Header from './organisms/Header';
import Quotas from './organisms/Quotas';

import { callThunk, fetchSavedDeliverySettings } from '~/api';
import { FONT_WEIGHTS, PALETTE } from '~/assets/styles/base';

const ContentBox = styled.div`
  width: 100%;
  padding: 30px;
  margin: ${({ addBottomMargin }) => (addBottomMargin ? '17px 0 30px' : '17px 0 0')};
  border: 1px solid ${PALETTE.border.frame};
  background: ${PALETTE.white};
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
`;

const ContentBoxTitle = styled(Typography)`
  font-weight: ${FONT_WEIGHTS.size2};
`;

const ContentsWrapper = styled.div`
  margin: 20px 0 0;
`;

const DeliveryDateAreaWrapper = styled.div`
  display: flex;
`;

function AdminSurvey() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // urlからidを取得
  const { id: surveyId } = useParams();

  // selector
  const survey = useSelector((state) => state.survey);
  const user = useSelector((state) => state.user);

  // hooks
  useEffect(() => {
    // storeを初期化する
    dispatch({ type: 'quotas/initialize' });
    dispatch({ type: 'qualifications/initialize' });
    dispatch({ type: 'enqueteCollectCounts/initialize' });
    dispatch({ type: 'invoiceRecipient/initialize' });
    dispatch({ type: 'surveyPayment/initialize' });
    dispatch({ type: 'judgement/initialize' });
    dispatch({ type: 'surveyRejectHistory/initialize' });
  }, []);

  useEffect(() => {
    (async () => {
      await dispatch(
        callThunk({
          action: fetchSavedDeliverySettings,
          payload: { surveyId },
        })
      );
    })();
  }, [surveyId]);

  return (
    <>
      <Header survey={survey} />

      <ContentBox addBottomMargin>
        <Quotas surveyStatusId={survey.surveyStatusId} />
      </ContentBox>

      <ContentBox addBottomMargin={!survey.moResearchId}>
        <FlexBox>
          <ContentBoxTitle variant="title2">{t('survey.deliveryDateTime')}</ContentBoxTitle>
        </FlexBox>
        {survey.deliveryDate && (
          <ContentsWrapper>
            <DeliveryDateAreaWrapper>
              <DeliveryDateArea isoDeliveryDate={survey.deliveryDate} canEdit={false} />
            </DeliveryDateAreaWrapper>
          </ContentsWrapper>
        )}
      </ContentBox>
      {survey.moResearchId && (
        <ContentBox>
          <>
            <FlexBox>
              <ContentBoxTitle variant="title2">{t('survey.moResearchId')}</ContentBoxTitle>
            </FlexBox>
            <ContentsWrapper>
              <Typography variant="title1">{survey.moResearchId}</Typography>
            </ContentsWrapper>
          </>
        </ContentBox>
      )}
      {user.id && (
        <ContentBox>
          <FlexBox>
            <ContentBoxTitle variant="title2">{t('appCommon.userInfo')}</ContentBoxTitle>
          </FlexBox>
          <ContentsWrapper>
            <UserInfoArea user={user} />
          </ContentsWrapper>
        </ContentBox>
      )}
    </>
  );
}

export default AdminSurvey;
